import { ResponseError } from 'shared/errors/responseError';
import { IExpertOfferSuggestionsSchema } from 'shared/repositories/cian-chat-bot/entities/expert_opinion_offer/ExpertOfferSuggestionsSchema';
import {
  fetchGetOfferSuggestions,
  TGetOfferSuggestionsResponse,
} from 'shared/repositories/cian-chat-bot/v1/get-offer-suggestions';

import { IApplicationContext } from '../../types/applicationContext';

interface IGetOfferSuggestionsParameters {
  offerId: number;
}

export async function getOfferSuggestions(
  { httpApi, logger }: IApplicationContext,
  parameters: IGetOfferSuggestionsParameters,
): Promise<IExpertOfferSuggestionsSchema[]> {
  try {
    const { response, statusCode }: TGetOfferSuggestionsResponse = await fetchGetOfferSuggestions({
      httpApi,
      parameters,
    });

    if (statusCode === 400) {
      logger.warning(
        new ResponseError({
          domain: 'getOfferSuggestions',
          message: response.message?.toString() || '',
          details: { errors: JSON.stringify(response.errors) },
        }),
      );

      return [];
    }

    return response.suggestions || [];
  } catch (e) {
    logger.warning(e, {
      degradation: 'Саджесты оффера для Циан-помощника',
      domain: 'getOfferSuggestions',
    });

    return [];
  }
}
